import { Link } from "react-router-dom";
import { CONTACT, waLink } from "@/lib/contact";

export const Footer = () => (
  <footer className="border-t border-amber-500/20 bg-[#0B0F17] pt-16 pb-8" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="w-3 h-3 bg-amber-500" />
            <span className="font-display text-4xl font-bold tracking-[0.15em] text-white">RORIX</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-zinc-500 max-w-sm">
            Manufacturer & supplier of road safety signage and traffic-calming hardware.
            Boom barriers, speed breakers, reflective systems — engineered in India, shipped pan-India.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono2 text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Navigate</p>
          <div className="flex flex-col gap-2.5">
            {[["Products", "#products"], ["Navkar Heights", "#project"], ["Manifesto", "#manifesto"], ["Get a Quote", "#contact"]].map(([label, href]) => (
              <a key={label} href={href} className="text-sm text-zinc-400 hover:text-amber-400 transition-colors duration-300" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                {label}
              </a>
            ))}
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono2 text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-4">Contact</p>
          <p className="text-sm text-zinc-300">{CONTACT.person}</p>
          <a href={`tel:+91${CONTACT.phone}`} className="block text-sm text-zinc-400 hover:text-amber-400 transition-colors mt-1" data-testid="footer-phone-link">
            {CONTACT.displayPhone}
          </a>
          <a href={waLink()} target="_blank" rel="noopener noreferrer" className="block text-sm text-emerald-400 hover:text-emerald-300 transition-colors mt-1" data-testid="footer-whatsapp-link">
            WhatsApp Business Chat
          </a>
          <Link to="/admin" className="inline-block mt-5 font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-600 hover:text-amber-400 transition-colors" data-testid="footer-admin-link">
            Admin Console →
          </Link>
        </div>
      </div>
      <div className="border-t border-zinc-800/70 pt-6 flex flex-wrap justify-between gap-3">
        <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-zinc-600">© 2026 Rorix Road Safety Systems</p>
        <p className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-zinc-600">Safety, Engineered To Be Seen.</p>
      </div>
    </div>
  </footer>
);
